import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CustomTranslateLoader } from '../providers/custom-translate-loader';

export function HttpLoaderFactory(http: HttpClient) {
    //return new TranslateHttpLoader(http);
    return new CustomTranslateLoader(http);
}